import React from "react";
import { Table, TableHead, TableBody, TableCell, TableRow, Grid, TableContainer, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";

const tableCellStyle = { color: "#222" };

export default function SingleMaintenanceTable(props) {
    const { t } = useTranslation("translation");

    return (
        <Grid container item md={12}>
            <Grid item xs={1} sm={3} md={2}></Grid>
            {/*Empty grid for alignment*/}
            <Grid item xs={10} sm={6} md={8}>
                <div style={{ overflow: "auto", marginBottom:"30px"}}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">{t("ID")} </TableCell>
                                <TableCell align="center">{t("EquipmentCode")} </TableCell>
                                <TableCell align="center">{t("Pool")} </TableCell>
                                <TableCell align="center">{t("MaintenanceNote")} </TableCell>
                                <TableCell align="center">{t("MaintenanceType")} </TableCell>
                                <TableCell align="center">{t("MaintenanceDates")} </TableCell>
                                <TableCell align="center">{t("PlannedPersonCount")} </TableCell>
                                <TableCell align="center">{t("Person/Hour")} </TableCell>
                           
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.singleMaintenanceExcel.map((row, index) => (
                                <TableRow style={{ background: row.hasWarning ? "#FF9089" : "aliceblue" }}>
                                    <TableCell sx={tableCellStyle} align="center">{index + 1}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.equipmentCode}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.poolCode}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.notes}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.maintenanceTypeCode}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.plannedDate}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.plannedPersonCount}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.plannedHoursPerPerson}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>


                
            </div>
            {props.warningList.length > 0 && props.singleMaintenanceExcel.length > 0 ? (
                    <>
                        <Grid item md={2}></Grid>
                        <Grid item md={12} style={{marginBottom:"30px"}}>
                            <TableContainer component={Paper} style={{ backgroundColor: "#FF9089" }}>
                                <Table sx={{ minWidth: 650, }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">{t("Line")}</TableCell>
                                            <TableCell align="center">{t("Warnings")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {props.warningList.map((row) => (
                                            <TableRow>
                                                <TableCell sx={tableCellStyle} align="center">{row.rowNumber - 1}</TableCell>
                                                <TableCell sx={tableCellStyle} align="center">{row.message}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item md={2}></Grid>
                    </>
                ) : null}
            </Grid>
            
        </Grid>
    );
}
